import { ReportsZeroState } from 'ui/illustrations';
import { useTranslation } from '../../../hooks';
import { InsightType } from '../../../types';
import { EmptyDataWrapper, EmptyDataTitle, EmptyDataSubtitle } from './EmptyData.styled';

export const DATA_TEST = {
  wrapper: 'empty-data-wrapper',
};

export const EmptyData = ({ type }: { type?: InsightType }) => {
  const { t } = useTranslation();
  const placeholderTitle =
    type === InsightType.behavioral ? t('insights.empty.event') : t('insights.empty.data');

  return (
    <EmptyDataWrapper data-test={DATA_TEST.wrapper}>
      <ReportsZeroState />
      <EmptyDataTitle>{placeholderTitle}</EmptyDataTitle>
      <EmptyDataSubtitle>{t('insights.empty.expand')}</EmptyDataSubtitle>
    </EmptyDataWrapper>
  );
};
